export default __webpack_public_path__ + "static/media/no_notification_icon.45fbb9e8.png";